import '../tables/Table.module.css'
function ScoringWeightsTableEditor(props) {


    let colGroup = (<>
        <colgroup>
                <col style={{minWidth:'100px'}} />
                <col style={{width:'150px'}} />
        </colgroup> 
    </>);

    const colNames =  ['Sub-Score', 'Scoring Weight'];   
    let tableHead = (
        <>
            <tr style={{fontSize: '14px'}}>
                {colNames.map((columnName, index) => (<th key={index} >{columnName}</th>))}
            </tr>
        </>);

    let tableRows = (<></>);
    tableRows = props.objectives.map((objective, id) => {
        if (objective.is_score){
            return(
                <tr key={`row_${id}`}>
                    <td key={`name_${id}`}>
                        <div style={{ fontSize: '14px' }}>
                            {objective.name}
                        </div>
                    </td>
                    <td key={`weight_${id}`}>
                            <input 
                                id={`scoring_weight_${id}`}
                                type='number' 
                                placeholder='value' 
                                autoComplete='false' 
                                value={objective.scoring_weight} 
                                onChange={props.inputHandler}
                                style={{fontSize: '14px', border:'0.5px solid var(--aixelo-gray)', width:'50px'}}/>
                    </td>
                </tr>);
        }
    });




    return(<>
        <table style={{ tableLayout: 'auto' , marginLeft:'25px', width:'fit-content'}}>
        {colGroup}
            <thead >
                {tableHead}
            </thead>
            <tr><div style={{height: '4px'}} colSpan={colNames.length}></div></tr>
            <tbody style={{border: '0.5px solid var(--aixelo-gray-light)'}}>
                {tableRows}
            </tbody>
        </table>
    </>
    );

}


export default ScoringWeightsTableEditor;
